export enum complianceTypeEnum {
  合规 = 0,
  试用 = 1,
}
